import { FilterTag } from '@aibees/elephant/feature/search-filters/components/filter-tags/components/filter-tag';
import { ViewMore } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { FilterTagListProps as Props } from './types';

const VIEW_MORE_BUTTON_PROPS = {
  variant: 'outlined' as const,
  size: 'xsmall' as const,
  color: 'default' as const,
};

export const FilterTagList = memo(
  ({ className, items, noTitle, disabledClear, removable }: Props) => {
    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        gap={0.5}
        className={classnames('FilterTagList', className)}
        sx={SX.root(disabledClear)}
      >
        {items.map((item) => (
          <Box
            display={'flex'}
            flexDirection={'column'}
            gap={0.5}
            key={item.field}
          >
            {item.group && !noTitle && (
              <Typography color="common.black" variant="body4">
                {item.name}
              </Typography>
            )}
            <ViewMore
              limit={3}
              displayTags={3}
              list={Object.values(item.data ?? {})?.map((tag) => (
                <FilterTag
                  key={tag.value}
                  data={tag ?? []}
                  info={item}
                  field={item.field}
                  utils={item.utils}
                  disabledClear={disabledClear}
                  removable={removable}
                />
              ))}
              buttonProps={VIEW_MORE_BUTTON_PROPS}
            />
          </Box>
        ))}
      </Box>
    );
  }
);

FilterTagList.displayName = 'FilterTagList';
